
export const STATUS = ['Todos', 'Dead', 'Alive', 'unknown']